// extracted by mini-css-extract-plugin
export default {"radio":"styles_radio__FlggU"};